import React, { useEffect, useState } from "react";
import "./Auction.scss";
import { Button, Skeleton } from "antd";
import largeModeImg from "@assets/icons/large-icons.svg";
import smallModeImg from "@assets/icons/small-icons.svg";
import ProductItem from "@components/ProductItem/ProductItem";
import Helpers from "@utils/Helpers";
import { ProductApi } from "services/ProductApi";
import { errorLog } from "logging";
import { useNavigate } from "react-router-dom";

const Auction: React.FC = () => {
  const [viewMode, setViewMode] = useState("large");
  const [products, setProducts] = useState<any>();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMyProduct = async () => {
      try {
        const response = await ProductApi.GetAll();
        if (response.status == 200) {
          setProducts(response.data.data);
        }
      } catch (error) {
        Helpers.notification.error("Can not fetch data. Please try again");
        errorLog("Auction.tsx - fetchMyProduct", error);
      }
    };

    if (!products) {
      fetchMyProduct();
    }
  }, [products]);
  return (
    <div className="Auction">
      <div className="container">
        <div className="section-title-group">
          <div className="section-title">Available Now</div>

          <div className="view-mode">
            <div
              onClick={() => setViewMode("large")}
              className={`large-mode ${viewMode === "large" && "mode"}`}
            >
              <img src={largeModeImg} alt="large-mode"/>
              <span className="mode-title">Large Icons</span>
            </div>
            <div
              onClick={() => setViewMode("small")}
              className={`small-mode ${viewMode === "small" && "mode"}`}
            >
              <img src={smallModeImg} alt="small-mode"/>
              <span className="mode-title">Small Icons</span>
            </div>
          </div>
        </div>
        {!products ? (
          <div
            className={`product-group ${
              viewMode === "large" ? "product-group-3" : "product-group-5"
            }`}
          >
            {Array.from({ length: 3 }).map((_, index) => {
              return (
                <div className="product-item" key={index}>
                  <div className="product-placeholder">
                    <Skeleton.Image active={true} className="skeleton-image" />
                    <div className="content">
                      <Skeleton active={true} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            className={`product-group ${
              viewMode === "large" ? "product-group-3" : "product-group-5"
            }`}
          >
            {products
              ?.sort((a: any, b: any) => b.product_id - a.product_id)
              .map((item: any, index: number) => {
                if (viewMode === "large" && index >= 3) return;
                if (viewMode === "small" && index >= 5) return;
                return (
                  <div className="product-item" key={index}>
                    <ProductItem
                      data={item}
                      isAuction={false}
                      type={"Product List"}
                      index={index}
                    />
                  </div>
                );
              })}
          </div>
        )}
        <div className="auction-action">
          <Button className="see-more-btn" onClick={() => navigate("/products")}>See More</Button>
        </div>
      </div>
    </div>
  );
};

export default Auction;
